var map = {
	"./elem1-ability1.gif": "6a51",
	"./elem2-ability1.gif": "e2a9",
	"./elem3-ability1.gif": "50fd",
	"./elem4-ability1.gif": "9f10",
	"./elem5-ability1.gif": "de43",
	"./elem6-ability1.gif": "fe23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1769";